const useIOS = () => {
	if (!navigator) return false

	return /iPad|iPhone|iPod/.test(navigator.userAgent)
}

export default useIOS
